import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';

import { GetTariffs } from '../actions/tariffs';
import { TariffState } from '../reducers/tariffs';
import {
  areTariffsLoaded,
  areTariffsLoading,
  getTariffs,
} from '../selectors/tariffs';

@Injectable()
export class TariffsFacade {
  public tariffs$ = this._store.select(getTariffs);
  public isLoading$ = this._store.select(areTariffsLoading);
  public isLoaded$ = this._store.select(areTariffsLoaded);

  constructor(private _store: Store<TariffState>) {}

  public getTariffs(userId: number): void {
    this._store.dispatch(GetTariffs(userId));
  }
}
